import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcGoodHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 11,
			fill: "#89B0FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.31444 14.536C9.57083 14.4335 9.86181 14.5582 9.96437 14.8146L9.50013 15.0003C9.96437 14.8146 9.96447 14.8148 9.96437 14.8146L9.96398 14.8136L9.96875 14.8244C9.97411 14.8364 9.98346 14.8567 9.99715 14.8841C10.0246 14.9389 10.0691 15.0217 10.1335 15.1234C10.2624 15.327 10.4691 15.6031 10.774 15.8803C11.3757 16.4273 12.3827 17.0003 14.0001 17.0003C15.6176 17.0003 16.6246 16.4273 17.2263 15.8803C17.5312 15.6031 17.7378 15.327 17.8668 15.1234C17.9311 15.0217 17.9757 14.9389 18.0031 14.8841C18.0168 14.8567 18.0262 14.8364 18.0315 14.8244L18.0366 14.8128C18.0367 14.8125 18.0369 14.812 18.0366 14.8128C18.1395 14.557 18.4297 14.4336 18.6858 14.536C18.9422 14.6386 19.0669 14.9296 18.9644 15.186L18.5001 15.0003C18.9644 15.186 18.9645 15.1857 18.9644 15.186L18.9633 15.1886L18.9618 15.1922L18.9577 15.2021C18.9544 15.2098 18.9501 15.2199 18.9446 15.2322C18.9336 15.2569 18.918 15.2903 18.8975 15.3313C18.8566 15.4132 18.7957 15.5257 18.7116 15.6584C18.5437 15.9235 18.2816 16.2724 17.899 16.6202C17.1257 17.3232 15.8827 18.0003 14.0001 18.0003C12.1176 18.0003 10.8746 17.3232 10.1013 16.6202C9.71871 16.2724 9.45658 15.9235 9.28866 15.6584C9.20459 15.5257 9.14368 15.4132 9.10272 15.3313C9.08223 15.2903 9.06668 15.2569 9.05569 15.2322C9.05019 15.2199 9.04582 15.2098 9.04254 15.2021L9.03843 15.1922L9.03696 15.1886L9.03638 15.1872C9.03626 15.1869 9.03589 15.186 9.50013 15.0003L9.03589 15.186C8.93334 14.9296 9.05805 14.6386 9.31444 14.536Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 12,
			r: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 12,
			r: 1,
			fill: "white"
		})
	]
});
export default SvgIcGoodHome;
